import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Collapse from '@material-ui/core/Collapse';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { API, Storage, Auth } from 'aws-amplify';
import { FaFileDownload } from 'react-icons/fa';

import DropDown from "../FormComponents/DropDown"

import { styles } from './util'
class CMAQResults extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            requestId: "CMAQ NH3 2019-10-25",

        };
        this.handleInputChange = this.handleInputChange.bind(this);

        // Avoid setting the state after the component was unmounted
        // https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
        this._isMounted = false;
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate() {
    }

    showJobInfo() {
        return (
            <div style={{width: '50%', float: 'left'}}>
                <DropDown
                    title='Select Job to View: '
                    name='requestId'
                    value={this.state.requestId}
                    dropdownOptions={
                        [{
                            value: "CMAQ NH3 2019-10-25",
                            label: "CMAQ NH3 2019-10-25"
                        }]
                    }
                    tooltip={[<div key='runOption0'>Project description from the UI Submit page.</div>]}
                />

                <h3> Job Status:  </h3> <p style={{'marginLeft': '20px'}}> SUCCEEDED </p>
                <h3> Job ID:      </h3> <p style={{'marginLeft': '20px'}}> 7bc0c8de37e54336a278a3d924699c3a </p>
                {this.showRequestBody()}
            </div>
        )
    }

    showRequestBody() {
            return (
                <div>
                    <Button
                        onClick={() => {this.setState({openRequestBodyTable: !this.state.openRequestBodyTable})}}
                        style={{width: '90%'}}
                        variant='outlined'
                    > Request Body </Button>

                <Collapse in={this.state.openRequestBodyTable} timeout="auto" unmountOnExit>
                        <Table style={{width: '90%'}} >
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='thin-column' > Variable </TableCell>
                                        <TableCell className='thick-column' > Value </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='thin-column' > Model </TableCell>
                                        <TableCell className='thick-column' > "CMAQ" </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='thin-column' > sdate </TableCell>
                                        <TableCell className='thick-column' > "2017040100" </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className='thin-column' > edate </TableCell>
                                        <TableCell className='thick-column' > "2017050100" </TableCell>
                                    </TableRow>
                                </TableHead>
                        </Table>
                    </Collapse>
                </div>
        )}

    render() {
        return (
            <div >
                <h1> Job Results </h1>
                {this.showJobInfo()}
                <div style={{width:'50%', float: 'right'}}>
                    <div>
                        <h3>Link to emissions data below.</h3>
                        <div style={{color: 'blue'}}> <u>DOWNLOAD RESULTS </u><FaFileDownload /> </div>
                        {this.state.resultTarFile && this.showResultTar()}
                    </div>
                </div>
            </div>
        )
    }
}

CMAQResults.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(CMAQResults);
